import { useCallback, useState } from 'react';

import { useClearApolloCache } from './useClearApolloCache';
import { useClearBackendCache } from './useClearBackendCache';

/**
 * Hook that provides a function to clear both backend and frontend caches
 * Useful for ensuring fresh data is fetched after operations that might affect cached data
 */
export function useClearCache(): {
  clearCache: () => Promise<void>;
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState(false);
  const clearApolloCache = useClearApolloCache();
  const clearBackendCache = useClearBackendCache();

  const clearCache = useCallback(async () => {
    setIsLoading(true);
    try {
      // Clear backend cache first, then frontend cache
      await clearBackendCache();
      await clearApolloCache();
    } finally {
      setIsLoading(false);
    }
  }, [clearBackendCache, clearApolloCache]);

  return { clearCache, isLoading };
}
